import { connect } from 'react-redux'
import { firebaseConnect, getVal } from 'react-redux-firebase'
import { branch, compose, renderNothing } from 'recompose'
import {
  profileSelector,
  userSelector
} from '../../../store/selectors/baseSelectors'
import { smallScreenSelector } from '../../../store/selectors/boardSelectors'

export default compose(
  firebaseConnect([{ type: 'once', path: '/plans' }]),
  connect(state => {
    const profile = profileSelector(state)
    return {
      subscription: profile && profile.subscription,
      plans: getVal(state.firebase.data, `/plans`),
      user: userSelector(state),
      smallScreen: smallScreenSelector(state)
    }
  }),
  branch(({ user }) => !user.displayName, renderNothing)
)
